import { LogNotification } from '@/api';

export const shouldShowNotificationInCenter = (notification: LogNotification) => notification.internal !== true;
